export function getPaymentMethod(paymentProviderType: string) {
  switch(paymentProviderType) {
    case 'Payex':
      return 'Kortbetalning'
    case 'InStore':
      return 'Betala i butik'
    default:
      return 'Kortbetalning'
  }
}